import { Type } from 'class-transformer';

export class CurriculumManagerUserModel {
	uid: number;
	first_name: string;
	preferred_first_name: string;
	last_name: string;
	currently_enrolled: boolean;
}

export function CurriculumUserModel_ClassTransform_Type() {
	return CurriculumManagerUserModel;
}

export class CurriculumManagerUserDrilldownModel {
	@Type(CurriculumUserModel_ClassTransform_Type)
	results: CurriculumManagerUserModel[];
	count: number;
}

export type CurriculumStudentDrilldownTypes =
	| 'course'
	| 'catalog'
	| 'graduation_plan'
	| 'section';

export type CurriculumTeacherDrilldownTypes = 'course' | 'section';
